import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const COLLAPSED_KEY = 'pc-sidebar-collapsed';

const readCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === 'true';
  } catch {
    return false;
  }
};

const persistCollapsed = (collapsed) => {
  try {
    localStorage.setItem(COLLAPSED_KEY, String(collapsed));
  } catch {}
};

const useSidebar = () => {
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState(() => new Set());

  const toggleCollapse = useCallback(() => {
    setCollapsed((current) => {
      persistCollapsed(!current);
      return !current;
    });
  }, []);

  const openMobile = useCallback(() => setMobileOpen(true), []);
  const closeMobile = useCallback(() => setMobileOpen(false), []);

  const toggleSubmenu = useCallback((id) => {
    setOpenSubmenus((current) => {
      const next = new Set(current);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!mobileOpen) return;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setMobileOpen(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [mobileOpen]);

  return { collapsed, toggleCollapse, mobileOpen, openMobile, closeMobile, openSubmenus, toggleSubmenu };
};

export default useSidebar;
